import { Theme } from '@material-ui/core/styles'
import { StyleRulesCallback } from '@material-ui/styles/withStyles/withStyles'

/**
 * Extends `parentStyles` with `childStyles`.
 * Curried version.
 * Apply to a style maker when exporting to simplify usage in child styles.
 * NOTE: Trying to make a complete wrapper (extendAll(child, p1, p2)) requires flowRight with any types :(
 * @example
 * const makeParentFoo = () => ({foo: {margin: 10}})
 * export const extendFooStyles = extendStylesF(makeParentFoo)
 * export const extendBarStyles = extendStylesF(makeParentBar)
 * const useStyles =
 *   makeStyles(
 *     extendFooStyles(
 *       extendBarStyles(
 *         () => ({foo: {margin: 42}})
 *       )))
 * // or
 * makeStyles(
 *   extendStylesF(makeParentFoo)(
 *     extendStylesF(makeParentBar)(
 *       () => ({foo: {margin: 42}})
 *     )))
 */
export const extendStyles =
  <TParentClassKey extends string>(parentStyles: StyleRulesCallback<Theme, {}, TParentClassKey>) =>
    <TChildClassKey extends string>(childStyles: StyleRulesCallback<Theme, {}, TChildClassKey>) =>
      (theme: Theme) => ({
        ...parentStyles(theme),
        ...childStyles(theme)
      })